<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_ii"></a><a id="page_iii"></a>The Pirate Captain Ned Low</h1>
<p class="titles">His Life and Mysterious Fate</p>
<p class="author">Nicky Nielsen</p>
<div class="img_container3">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?1d6b34e1